
(function() {
  var result = { translations: { "sl": { "i18n": { "duration": { "seconds": "{{ seconds }} sekund", "minutes": "{{ minutes }} min", "hours": "{{ hours }} ur", "hoursAndMinutes": "{{ hours }} ur {{ minutes }} minut", "days": "{{ days }} dni", "shortForm": { "seconds": "{{ seconds }} sekund", "minutes": "{{ minutes }} minut", "hours": "{{ hours }} ur", "days": "{{ days }} dni", "hoursAndMinutes": "{{ hours }} ur {{ minutes }} minut" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, zun. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "sl": "static-7.1304"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1304",
    "ar-eg": "static-7.1304",
    "bg": "static-7.1304",
    "bn": "static-7.1304",
    "ca-es": "static-7.1304",
    "cs": "static-7.1304",
    "da": "static-7.1304",
    "de": "static-7.1304",
    "el": "static-7.1304",
    "en-gb": "static-7.1304",
    "en": "static-7.1304",
    "es-mx": "static-7.1304",
    "es": "static-7.1304",
    "et": "static-7.1304",
    "fi": "static-7.1304",
    "fr-ca": "static-7.1304",
    "fr": "static-7.1304",
    "he-il": "static-7.1304",
    "hi": "static-7.1304",
    "hr": "static-7.1304",
    "hu": "static-7.1304",
    "id": "static-7.1304",
    "it": "static-7.1304",
    "ja": "static-7.1304",
    "ko": "static-7.1304",
    "lt": "static-7.1304",
    "ms": "static-7.1304",
    "nl": "static-7.1304",
    "no": "static-7.1304",
    "pl": "static-7.1304",
    "pt-br": "static-7.1304",
    "pt-pt": "static-7.1304",
    "ro": "static-7.1304",
    "ru": "static-7.1304",
    "sk": "static-7.1304",
    "sl": "static-7.1304",
    "sv": "static-7.1304",
    "th": "static-7.1304",
    "tl": "static-7.1304",
    "tr": "static-7.1304",
    "uk": "static-7.1304",
    "vi": "static-7.1304",
    "x-pseudo": "static-7.1304",
    "zh-cn": "static-7.1304",
    "zh-hk": "static-7.1304",
    "zh-tw": "static-7.1304"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:sl', {version: 'static-7.1304'}); }
})();


